import React from "react";
import { FOOTER } from "../../../layout/kor/footer";
import { SUBHEADER } from "../../../layout/kor/subheader";
import { History } from "../../../parts/kor/intro/history";
export const HISTORY = () => {
  return (
    <main id="content">
      <SUBHEADER />
      <div id="intro">
        <History />
      </div>
      <FOOTER />
    </main>
  );
};
